import React, { useContext } from "react";
import ReactDOM from "react-dom";
import ShoppingCartProvider, {
    ShoppingCartContext
} from "../../Providers/ShoppingCartProvider/ShoppingCartProvider";
import Products from "./Products";
import CartTotals from "./CartTotals";
import TranslationProvider, {
    TranslationContext
} from "../../Providers/TranslationProvider";

const ShoppingCart = () => {
    const { products, productAdded } = useContext(ShoppingCartContext);
    const { trans } = useContext(TranslationContext);
    if (products.length === 0) {
        return (
            <div className="container mx-auto pt-4">
                <div
                    style={{
                        borderRightColor: "#FEEBC8",
                        borderTopColor: "#FEEBC8",
                        borderBottomColor: "#FEEBC8"
                    }}
                    className="rounded bg-orange-100 border-l-4 border-orange-500 text-orange-700 border p-4 "
                    role="alert"
                >
                    <p className="font-bold">Je winkelwagen is leeg </p>
                    <p>Voeg eerst producten toe.</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="flex justify-between py-6">
                <button
                    className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 cursor-pointer"
                    onClick={() => window.location.replace(`/`)}
                >
                    <i className="fas fa-chevron-left pr-2" />
                    <span className="">verder winkelen</span>
                </button>
                <button
                    className="bg-yellow-200 text-yellow-900 px-4 py-2 rounded cursor-pointer font-bold hover:bg-yellow-300 flex items-baseline uppercase"
                    onClick={() => window.location.replace(`/checkout`)}
                >
                    <span>Bestellen</span>
                    <i className="fas fa-chevron-right pl-2" />
                </button>
            </div>
            <div className="flex flex-wrap -mx-6">
                <div className="w-full px-6 lg:w-9/12">
                    <div className="flex justify-between">
                        <h1 className="font-head text-xl mb-4">
                            Winkelwagen{" "}
                            {products.length === 1
                                ? `(${products.length} artikel)`
                                : `(${products.length} artikelen)`}
                        </h1>
                    </div>
                    <div className="flex flex-col">
                        <Products />
                    </div>
                    <div className="hidden lg:flex justify-between py-6">
                        <button
                            className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 cursor-pointer"
                            onClick={() => window.location.replace(`/`)}
                        >
                            <i className="fas fa-chevron-left pr-2" />
                            <span className="">verder winkelen</span>
                        </button>
                        <button
                            className="bg-yellow-200 text-yellow-900 px-4 py-2 rounded cursor-pointer font-bold hover:bg-yellow-300 flex items-baseline uppercase"
                            onClick={() => window.location.replace(`/checkout`)}
                        >
                            <span>Bestellen</span>
                            <i className="fas fa-chevron-right pl-2" />
                        </button>
                    </div>
                </div>
                <div className="w-full px-6 lg:w-3/12 ">
                    <CartTotals />
                </div>
            </div>
        </>
    );
};

export default ShoppingCart;

if (document.getElementById("shoppingcart")) {
    const element = document.getElementById("shoppingcart");

    // create new props object with element's data-attributes
    // result: {tsId: "1241"}
    // const props = Object.assign({}, element.dataset)

    // render element with props (using spread)
    ReactDOM.render(
        <TranslationProvider {...element.dataset}>
            <ShoppingCartProvider {...element.dataset}>
                <ShoppingCart />
            </ShoppingCartProvider>
        </TranslationProvider>,
        document.getElementById("shoppingcart")
    );
}
